import { Button } from "@/ui/button";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import { useGetBotDefaultSlippage } from "@/api/bot/bot-get-default-slippage";
import { useToken } from "@/pages/token-v2/hooks/use-token";

import { FC } from "react";
import { formatDecimalStringFloat } from "@/utils/currency";

const SlippageToggleInput: FC<{
  title: string;
  isAuto: boolean;
  value: string;
  onAutoChange: () => void;
  onValueChange: (v: string) => void;
}> = ({ title, isAuto, value, onAutoChange, onValueChange }) => {
  const { data: defaultSlippage } = useGetBotDefaultSlippage();

  const token = useToken();

  const chain = (
    token?.pair?.networkId === 1 ? "ethereum" : "solana"
  ) as string;

  const defaultValue =
    chain === "ethereum"
      ? defaultSlippage?.ethereumSlippage?.toString()
      : defaultSlippage?.solanaSlippage?.toString();

  return (
    <GradientBorderRadius radius="bigger" gradient="default-border">
      <div className="flex items-center gap-[0.325rem] px-2 py-[0.125rem]">
        <div className="text-xs font-semibold">{title}</div>
        <Button
          title="Auto"
          active={isAuto}
          height="h-[1.25rem]"
          className="text-xs w-[2.75rem]"
          onClick={() => onAutoChange()}
        />
        <div className="flex items-center">
          <input
            className="w-[2rem] h-[1.25rem] dark:text-white text-black text-xs bg-transparent focus:outline-none  border-[0.1875rem] border-transparent placeholder:text-gray font-normal text-right border-none"
            type="number"
            value={
              isAuto
                ? (defaultValue ?? "") // fallback na prazan string ako još nije učitano
                : value
            }
            placeholder={defaultValue}
            onChange={(e) => {
              const newValue = e.target.value;
              if (Number(newValue) > 100) {
                onValueChange("100");
                return;
              }
              if (Number(newValue) < 0) {
                onValueChange("0");
                return;
              }

              const formattedValue = formatDecimalStringFloat(
                newValue,
                true,
                false
              );

              onValueChange(formattedValue);
            }}
          />
          <span className="text-xs ml-[0.125rem]">%</span>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default SlippageToggleInput;
